import { useEffect } from 'react';

import { SESSION_STORAGE_KEYS } from 'constants/sessionStorageKeys';

import { isProduction, useAppDispatch } from 'shared/lib';
import { customSessionStorage } from 'shared/lib/customStorage';

import { updateAbExperiments } from '../model/abExperiments.slice';

type ExperimentsStorageItem = Record<string, string>;

export const useDevAbExperiments = () => {
  const isDevelopment = !isProduction();
  const dispatch = useAppDispatch();

  const loadDevExperimentFromLocal = (): ExperimentsStorageItem | null => {
    try {
      const customExperiments = customSessionStorage.get(SESSION_STORAGE_KEYS.localDevExperiments);
      if (!customExperiments) {
        return null;
      }
      return JSON.parse(customExperiments) as ExperimentsStorageItem;
    } catch (e) {
      return null;
    }
  };

  const saveDevExperimentsLocal = (name: string, value: string) => {
    const newExperiments = {
      ...loadDevExperimentFromLocal(),
      [name]: value,
    };
    customSessionStorage.set(SESSION_STORAGE_KEYS.localDevExperiments, JSON.stringify(newExperiments));
  };

  const setDevExperiments = () => {
    const devExperiments = loadDevExperimentFromLocal();
    if (!devExperiments) {
      return;
    }
    dispatch(updateAbExperiments(devExperiments));
  };

  useEffect(() => {
    if (isDevelopment && typeof window !== 'undefined') {
      setDevExperiments();

      window.setDevAbExperiment = (name: unknown, value: unknown) => {
        if (typeof name !== 'string' || typeof value !== 'string' || !name || !value) {
          return;
        }
        dispatch(updateAbExperiments({ [name]: value }));
        saveDevExperimentsLocal(name, value);
      };
      window.clearDevAbExperiments = () => {
        customSessionStorage.remove(SESSION_STORAGE_KEYS.localDevExperiments);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
